export function getSpreadElements(elements, spreadId) {
  if (!elements || !Array.isArray(elements)) {
    console.warn('Invalid elements array:', elements);
    return [];
  }

  return elements.filter(element => element.spreadId === spreadId);
}

export function organizeElementsBySpread(elements) {
  if (!elements || !Array.isArray(elements)) {
    console.warn('Invalid elements array for organizing spreads:', elements);
    return {};
  }

  const spreads = elements.reduce((acc, element) => {
    const { spreadId } = element;
    if (!spreadId) {
      console.warn('Element missing spreadId:', element);
      return acc;
    }

    if (!acc[spreadId]) {
      acc[spreadId] = { elements: [] };
    }
    acc[spreadId].elements.push(element);
    return acc;
  }, {});

  // Sort elements within each spread
  Object.values(spreads).forEach(spread => {
    spread.elements.sort((a, b) => {
      // Sort by position.x to ensure consistent ordering
      return (a.position?.x || 0) - (b.position?.x || 0);
    });
  });

  console.log('Organized spreads:', spreads);
  return spreads;
}